module.exports = __webpack_public_path__ + "static/img/RAW1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAW1_1.png
// module id = WE/r
// module chunks = 0